import { render, staticRenderFns } from "./list-shipping-delayed-btn.vue?vue&type=template&id=455eeecc&"
import script from "./list-shipping-delayed-btn.vue?vue&type=script&lang=js&"
export * from "./list-shipping-delayed-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports